import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../components/global/modal/withModal';

const propTypes = {
  className: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const AccountCardStickerConfirm = ({ className, onConfirm, onDismiss }) => {
  const classes = classNames({
    'account-card-sticker-modal': true,
    'alert-modal-content': true,
    [className]: !!className,
  });

  return (
    <Fragment>
      <div className={classes}>
        <p className="text-extra-bold">
          Do you want to add your own personalized stamp?
        </p>
      </div>

      <div className="account-card-sticker-modal-actions">
        <button onClick={onDismiss} className="btn-account-card-dismiss">
          No, thanks
        </button>

        <button onClick={onConfirm} className="btn-account-card-add">
          Yes!
        </button>
      </div>
    </Fragment>
  );
};

AccountCardStickerConfirm.propTypes = propTypes;

export default withModal(AccountCardStickerConfirm, {
  hideHeader: true,
  dismissible: false,
  size: 'xs',
  className: 'alert-modal',
  overlayClassName: 'alert-modal-overlay',
  shouldCloseOnOverlayClick: false,
});
